import { cn } from "@/utils/cn";

export interface LabelProps {
  htmlFor?: string;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

export function Label({
  htmlFor,
  required,
  className,
  children,
}: LabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        "block text-sm font-medium text-slate-700 mb-1",
        required && "after:content-['*'] after:ml-0.5 after:text-red-500",
        className
      )}
    >
      {children}
    </label>
  );
}
